import classNames from 'classnames';
import type { DateTime } from 'luxon';
import React from 'react';
import type { ElementProps } from '../../element/Element';
import { Element } from '../../element/Element';
import type { TimelineItemPositioningProps } from '../Timeline.types';
import { timelineItemPositioning } from '../Timeline.utils';
import styles from './Timeline.AdjustableSelection.module.scss';

type Range = {
  started_at: DateTime;
  ended_at: DateTime;
  // Todo: Look at similar types, consider merging, ref HourTimestamp++
};

export interface AdjustSelectionProps extends ElementProps {
  onSelectionEnd: (range: Range) => void;
  onSelectonRemove: (range: Range) => void;
}

/**
 * @TODO consider baking directly into `Event` component?
 * Not likely we want re-sizable/movable `Event` components eventually.
 * Might work well as wrapper for "anything"?
 */
export const TimelineAdjustableSelection = (
  props: AdjustSelectionProps & TimelineItemPositioningProps
) => {
  const { offsetPx, sizePx, orientation, style, onSelectionEnd, onSelectonRemove, ...rest } = props;
  const dynamicStyles = timelineItemPositioning(props);
  return (
    <Element
      {...rest}
      style={{ ...dynamicStyles, ...style }}
      className={classNames(styles.adjustableContainer, props.className)}
    >
      {/* @todo */}
      <AdjustHandle placement="start" />
      <AdjustHandle placement="end" />
    </Element>
  );
};
TimelineAdjustableSelection.displayName = 'Timeline.AdjustableSelection';

const AdjustHandle = (props: { placement: 'start' | 'end' }) => {
  const { placement } = props;
  return (
    <div
      className={classNames(styles.adjustHandle, styles[`placement-${placement}`])}
      draggable
      data-adjust-handle // @todo: Dont allow selection mode on this attr.
      onDragStart={e => {
        console.info('@todo onDragStart', e);
      }}
    />
  );
};
AdjustHandle.displayName = 'Timeline.AdjustableSelection.Handle';
